var map = {
	"./australia.ts": [
		720,
		720
	],
	"./colombia.ts": [
		246,
		246
	],
	"./denmark.ts": [
		92,
		92
	],
	"./england.ts": [
		667,
		667
	],
	"./france.ts": [
		539,
		539
	],
	"./jamaica.ts": [
		456,
		456
	],
	"./japan.ts": [
		450,
		450
	],
	"./morocco.ts": [
		872,
		872
	],
	"./netherlands.ts": [
		722,
		722
	],
	"./nigeria.ts": [
		77,
		77
	],
	"./norway.ts": [
		550,
		550
	],
	"./south_africa.ts": [
		364,
		364
	],
	"./spain.ts": [
		455,
		455
	],
	"./sweden.ts": [
		116,
		116
	],
	"./switzerland.ts": [
		827,
		827
	],
	"./usa.ts": [
		601,
		601
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 785;
module.exports = webpackAsyncContext;